<template>
    <section>
        <nav class="tabs mb-3 w-100 scrollable">
            <a v-for="tab in tabs" :class="{ 'tabs__item': true, 'tabs__item--active': tab.isActive }" :href="tab.href" @click.prevent="selectTab(tab)">
                {{ tab.name }}
            </a>
        </nav>

        <slot></slot>
    </section>
</template>

<script>
    export default {
        props: {
            height: {
                type: Number,
                required: false
            },
            type: {
                type: String,
                required: false
            },
            event: {
                type: String,
                required: true
            }
        },

        data() {
            return {
                tabs: []
            };
        },

        methods: {
            selectTab(selectedTab, runEvent = true) {
                if (runEvent) {
                    this.runEvent(selectedTab.name);
                }

                this.tabs.forEach(tab => {
                    tab.isActive = tab.name === selectedTab.name;
                });

                selectedTab.updateSwiper();
            },

            runEvent(name) {
                $app.runEvent('click', {
                    'вкладки': {
                        [this.event]: name
                    }
                })
            }
        },

        mounted() {
            this.tabs = this.$children;

            if (this.tabs.length === 1) {
                this.selectTab(this.tabs[0], false);
            }

            this.$nextTick(() => {
                this.tabs.forEach(tab => {
                    if (tab.$el.offsetParent && this.height) {
                        tab.collapse(this.height)
                    }
                })
            })
        }
    }
</script>